import './LoaderOverlay.scss';

export type LoaderOverlayProps = {
    showLoader: boolean
}

const LoaderOverlay = ({showLoader}: LoaderOverlayProps) => {
    if (!showLoader) return null;

    return (
        <div className="loader-overlay">
            <div className="loader-spinner" />
        </div>
    );
};

export default LoaderOverlay;
